export default __webpack_public_path__ + "static/media/distributor-graphic2.d6ded72c.png";